import { Injectable } from '@angular/core';
import { BaseResponse, CommunicationChannelDto } from '@shared/utils/interfaces';
import { Observable } from 'rxjs';

@Injectable()
export abstract class CommunicationChannelApiService {
  abstract getCommunicationChannels(regionId: number, entityId: string): Observable<BaseResponse<CommunicationChannelDto[]>>;
  abstract createCommunicationChannel(data: CommunicationChannelDto, regionId: number, entityId: string): Observable<BaseResponse<void>>;
  abstract updateCommunicationChannel(
    data: CommunicationChannelDto,
    regionId: number,
    entityId: string,
    channelId: string,
  ): Observable<BaseResponse<void>>;
  abstract deleteCommunicationChannel(regionId: number, entityId: string, channelId: string): Observable<BaseResponse<void>>;
}
